import { defaultColors } from '../../../../Common/Services/contexts/ServicesChartsDataContext';
import { useVaccinationChartsDataContext } from './useVaccinationChartsDataContext';

const useTotalVaccinationByAge = () => {
    const { chartData } = useVaccinationChartsDataContext();

    const categories = chartData.totalVaccinationByAge.map(
        (item) => item.description
    );

    const subtitles = ['Vacinação', 'Vacinação - Ano Anterior'];

    const series = subtitles.map((item) => {
        const data = categories.map((category) => {
            const found = chartData.totalVaccinationByAge.find(
                (counter) =>
                    counter.description === category
            );

            let value = 0;

            switch (item) {
                case 'Vacinação':
                    value = found ? found.totalYear : 0;
                    break;
                case 'Vacinação - Ano Anterior':
                    value = found ? found.totalPreviousYear : 0;
                    break;
                default:
                    value = 0;
                    break;
            }

            return Number(value);
        });

        return {
            name: item,
            data,
            type: item === 'Vacinação' ? 'bar' : 'line'
        };
    });

    const chartConfig = {
        series: series,
        options: {
            chart: {
                type: 'line',
                height: 400,
                stacked: false,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '50%',
                    endingShape: 'rounded',
                    dataLabels: {
                        position: 'top'
                    }
                }
            },
            yaxis: {
                labels: {
                    formatter: (val) => val.toLocaleString('pt-BR')
                }
            },
            stroke: {
                width: [4, 4]
            },
            xaxis: {
                categories: categories || []
            },
            legend: {
                position: 'top',
                offsetY: 10
            },
            dataLabels: {
                enabled: true,
                style: {
                    fontSize: '12px',
                    colors: ['#000']
                },
                offsetY: -20,
                enabledOnSeries: [0]
            },
            tooltip: {
                enabled: true,
                style: {
                    fontSize: '16px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Arial, sans-serif',
                    padding: '10px',
                    pointerEvents: 'auto',
                    zIndex: '1000'
                },
                y: {
                    formatter: (val) => (val ? val.toLocaleString('pt-BR') : '')
                }
            },
            colors: defaultColors
        }
    };

    return {
        chartConfig
    };
};

export default useTotalVaccinationByAge;
